import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { MenuManagementBrandItemService } from '@/services/BrandItem/MenuManagementItemService';

export type SearchOptionItemsParams = {
  associate_brand_id: string;
  title: string;
};

export const useMenuManagementSearchOptionItems = async (
  params: SearchOptionItemsParams
): Promise<SearchItem[]> => {
  const menuManagementBrandItemService = new MenuManagementBrandItemService(
    getClient()
  );
  try {
    return await menuManagementBrandItemService.searchOptionGroupItems(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
